import React, { Fragment } from 'react';

import Player from '@vimeo/player';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade, EffectCoverflow } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';
import Vimeo from '@u-wave/react-vimeo';
SwiperCore.use([Navigation , EffectFade, A11y]);
class MainSlider extends React.Component {	
  constructor(props){
    super(props);
    this.handleSound = this.handleSound.bind(this)
  }

    handleSound(){
        let btnSound = document.querySelector('.toggle-sound');
        let cSwiper  = document.querySelector('.swiper-slide.swiper-slide-active');
        let oSwipers = document.querySelectorAll('.swiper-slide:not(.swiper-slide-active)');

        // mute / unmute current iframe
        let ciframe = cSwiper.querySelector('iframe');
        if(ciframe){
            let cplayer = new Player(ciframe);
            cplayer.getMuted().then(function(muted) {
                if(muted){
                    cplayer.setMuted(0);
                    btnSound.classList.remove('sound-on');
                    btnSound.classList.add('sound-off');
                }
                else{
                    cplayer.setMuted(1);
                    btnSound.classList.remove('sound-off');
                    btnSound.classList.add('sound-on');
                }
            })
        }

        // mute others iframes
        [...oSwipers].forEach((oSwiper) => {
            let oiframe = oSwiper.querySelector('iframe');
            if(oiframe){
                let oplayer = new Player(oiframe);
                oplayer.setMuted(1);
            }
        })
    }


    handleVideos(){
        // reset sound btn class
        let btnSound =  document.querySelector('.toggle-sound');
                        btnSound.classList.remove('sound-off');
                        btnSound.classList.add('sound-on');

        // if current swipe has iframe then show sound btn else hide
        setTimeout(() => {
            let cSwiper = document.querySelector('.swiper-slide.swiper-slide-active');
            let ciframe = cSwiper ? cSwiper.querySelector('iframe') : '';
            ciframe ? btnSound.style.visibility = 'visible' : btnSound.style.visibility = 'hidden';
        }, 50);


        // mute all iframes
        let aSwipers = document.querySelectorAll('.swiper-slide');
        [...aSwipers].forEach((aSwiper) => {
            let aiframe = aSwiper.querySelector('iframe');
            if(aiframe){
                let aplayer = new Player(aiframe);
                aplayer.setMuted(1);
            }
        })
    }
   
  render() {
    let page_id = this.props.page_id;
    let _this = this;
    let handleClickBelow = this.props.handleClickBelow;
    let sliders = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.main_slider.slide : [];
    let logo = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.main_slider.logo : [];
   
    let sliderData = sliders.map((item, key) => {
        let logo_html = item.show_logo == 1 ? `<img class="--logo" src="${logo.url}" alt="${logo.alt}" title="${logo.title}" />` : '';
        let media = `${logo_html}<img class="fullScreen-upto-tabL" src="${item.image.url}" alt="${item.image.alt}" title="${item.image.title}" />`;
        if(item.type == 1){
            media = `${logo_html}<img class="fullScreen-upto-tabL" src="${item.image.url}" alt="${item.image.alt}" title="${item.image.title}" />`
        }else{
            if(item.video){
                switch (Number(item.video.platform)) {
                    case 1:
                        media = `${logo_html}<iframe src="https://player.vimeo.com/video/${item.video.video_id}?autoplay=1&amp;loop=1&amp;muted=1&amp;title=0&amp;byline=0&amp;portrait=0&amp;background=1&amp;autopause=0" allow="autoplay; encrypted-media"></iframe>`;
                        break;
                    case 2:
                        media = `${logo_html}<iframe src="https://www.youtube.com/embed/${item.video.video_id}?mute=1&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;modestbranding=1&amp;autohide=1" allow="autoplay; encrypted-media"></iframe>`;
                        // version=3&autoplay=1&controls=0&showinfo=0&loop=1&modestbranding=1&autohide=1"
                        break;
                    default:
                        media = `${logo_html}<iframe src="https://www.youtube.com/embed/${item.video.video_id}?mute=1&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;modestbranding=1&amp;autohide=1" allow="autoplay; encrypted-media"></iframe>`;
                        break;
                }
            }
        }
                            
        return (
            <SwiperSlide key={key}>
                {
                    /* if video */
                    item.video.platform == 1 && item.video.video_id && 
                    <div className="video-wrapper" dangerouslySetInnerHTML={{__html:media}} />
                }
           
                {
                    /* if img */
                    item.type == 1 &&
                    <figure dangerouslySetInnerHTML={{__html:media}} />
                }
                {
                    item.heading &&
                    <figcaption>
                        <div className="main-container">
                            <h6 className="title">{item.heading}</h6>
                            <a href={ item.link } className="btn-arw right">{item.link_text}</a>
                        </div>
                    </figcaption>
                }
                
            </SwiperSlide>
        )
    })
    return (
        <section className="section" data-hammenu="white">
            <div className="ll__gallery ll__home--hero">

                    <div className="fig-actions">
                        <div className="main-container">
                            <div className="inner-container text-right">
                                <a href="javascript:void(0)" className="toggle-sound sound-on" onClick={_this.handleSound}></a>
                            </div>
                        </div>
                    </div>

                    <Swiper 
                        effect={"fade"}
                        loop={true}
                        navigation
                        onInit={(swiper) => {
                            this.handleVideos();
                        }}

                        onSlideChange={(swiper) => {
                            this.handleVideos();
                        }}
                    >
                        {sliderData}
                    </Swiper>
                    
                {/* <img className="--logo" src={logo.url} alt={logo.alt} title={logo.title} /> */}
                <a href="javascript:" id="btn--scroll-down"  onClick={handleClickBelow}></a>
            </div>
        </section>
    );
  }
}

export default MainSlider;



// WEBPACK FOOTER //
// ./src/components/Home/MainSlider.js